var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerupCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4168_5377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4168_5377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88433e-08 6.21179C-7.35128e-05 5.69119 0.140485 5.17976 0.407533 4.72895C0.674581 4.27815 1.0587 3.90387 1.52123 3.64379L6.48123 0.853786C6.94322 0.593863 7.46723 0.457031 8.00062 0.457031C8.53401 0.457031 9.05801 0.593863 9.52 0.853786L14.4788 3.64379C14.9413 3.90387 15.3254 4.27815 15.5925 4.72895C15.8595 5.17976 16.0001 5.69119 16 6.21179V11.787C16.0001 12.3076 15.8595 12.819 15.5925 13.2698C15.3254 13.7206 14.9413 14.0949 14.4788 14.355L9.51877 17.145C9.05678 17.4049 8.53277 17.5417 7.99938 17.5417C7.46599 17.5417 6.94199 17.4049 6.48 17.145L1.52123 14.355C1.0587 14.0949 0.674581 13.7206 0.407533 13.2698C0.140485 12.819 -7.35128e-05 12.3076 2.88433e-08 11.787V6.21179Z",
    fill: "#ED64A6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4168_5377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5L8 9L16 4.5L8 0L0 4.5Z",
    fill: "#FFD980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9V18L16 13.5V4.5L8 9Z",
    fill: "#8F6400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5L8 18V9L0 4.5V13.5Z",
    fill: "#FFBC1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4168_5377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerupCube);
export default __webpack_public_path__ + "static/media/powerup_cube.27725a37b0e1a5f28b773f33176211d7.svg";
export { ForwardRef as ReactComponent };